import { Box, Flex, HStack, Text, useToast } from '@chakra-ui/react'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { ThumbsButtons } from 'components/ThumbsButtons'
import { useState, type FC } from 'react'

import { useCaptureEvent } from '../../utils/analytics'

type Props = {
  customSummary: string | null
  rootCause: string | null
  conversationUid: string
}

export const SummaryBox: FC<Props> = ({
  customSummary,
  rootCause,
  conversationUid,
}) => {
  const toast = useToast()
  const [isReviewed, setIsReviewed] = useState(false)
  const captureEvent = useCaptureEvent()

  return (
    <Box position="relative" borderRadius="0 0 16px 16px" w="100%" mb="1px">
      <Flex alignItems="start" gap={1} px={4} py={2} w="100%">
        <Box w="100%">
          <HStack align="flex-start">
            <Flex gap="3" flexDir="column">
              <Box>
                <Text
                  color="greys.400"
                  fontSize="sm"
                  fontWeight="semibold"
                  textTransform="uppercase"
                >
                  <Trans>Call reason description</Trans>
                </Text>
                <Text
                  color="greys.600"
                  fontWeight="300"
                  whiteSpace="break-spaces"
                >
                  {rootCause}
                </Text>
              </Box>
              <Box>
                <Text
                  color="greys.400"
                  fontSize="sm"
                  fontWeight="semibold"
                  textTransform="uppercase"
                >
                  <Trans>Additional details</Trans>
                </Text>
                <Text
                  color="greys.600"
                  fontWeight="300"
                  whiteSpace="break-spaces"
                >
                  {customSummary}
                </Text>
              </Box>
            </Flex>
            {!isReviewed && (
              <HStack
                gap="1"
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
              >
                <ThumbsButtons
                  onUp={() => {
                    captureEvent('widgetsummary_ThumbsUp', {
                      summary: customSummary ?? '',
                      rootCause: rootCause ?? '',
                      conversationUid,
                    })
                    setIsReviewed(true)
                    toast({
                      title: t`Thank you for the feedback`,
                      description: t`You are helping us to improve future summaries`,
                      status: 'success',
                      duration: 4000,
                      isClosable: true,
                    })
                  }}
                  onDown={() => {
                    captureEvent('widgetsummary_ThumbsDown', {
                      summary: customSummary ?? '',
                      rootCause: rootCause ?? '',
                      conversationUid,
                    })
                    setIsReviewed(true)
                    toast({
                      title: t`Thank you for the feedback`,
                      description: t`You are helping us to improve future summaries`,
                      status: 'success',
                      duration: 4000,
                      isClosable: true,
                    })
                  }}
                />
              </HStack>
            )}
          </HStack>
        </Box>
      </Flex>
    </Box>
  )
}
